import LoadingWrapper from "../../shared/components/LoadingWrapper";
import { OktaWidgetInlineLazy } from "../components/OktaWidgetInlineLazy";
import React from "react";

// Inline login mask.
// Initially we used the redirect to Okta mask approach.
// However this created some trouble for the internal accounts.
// When using the SSO option the login redirected back to a dashboard panel.
// DXO team advised that we should use the inline mask and directed us to the POC project.
// From there we have the current approach of rendering the Login mask inline.
const LoginPage: React.FC = () => {
  return (
    <React.Suspense
      fallback={<LoadingWrapper isLoading={true} loadingIndicatorClassName="text-green" loadingIndicatorSize="lg" />}
    >
      <OktaWidgetInlineLazy />
    </React.Suspense>
  );
};

export default LoginPage;
